/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { APP_LOADER_URL } from '../../../saas/AppStorageStaticNames';
import { getStringFromLS } from '../../helper-utils/localStorage';

function AppPreviewLoader({ service = 'flight' }) {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ backgroundColor: '#fff', minHeight: 'calc(100vh - 107px)' }}
    >
      <span className="fs-16 fs-400" style={{ fontWeight: '300' }}>
        <FormattedMessage id="please_wait" />
      </span>
      <img src={getStringFromLS(APP_LOADER_URL)} height="180px" />
      <span
        className="fs-14 fs-400 text-center px-2"
        style={{ fontWeight: '300' }}
      >
        <FormattedMessage id="loading" />{' '}
        {service === 'flight' ? 'Connecting with airline systems.' : ''}
        Almost there!
      </span>
    </div>
  );
}

export default AppPreviewLoader;
